export const CATEGORIES = [
  {
    value: 'legal',
    label: 'Legal/Jurídico',
    dot: 'bg-indigo-500',
    icon: 'i-lucide-gavel',
    color: 'bg-indigo-100 text-indigo-700',
  },
  {
    value: 'contabil',
    label: 'Contábil',
    dot: 'bg-emerald-500',
    icon: 'i-lucide-calculator',
    color: 'bg-emerald-100 text-emerald-700',
  },
  {
    value: 'midia',
    label: 'Mídia',
    dot: 'bg-pink-500',
    icon: 'i-lucide-video',
    color: 'bg-pink-100 text-pink-700',
  },
  {
    value: 'operacional',
    label: 'Operacional',
    dot: 'bg-amber-500',
    icon: 'i-lucide-hard-hat',
    color: 'bg-amber-100 text-amber-700',
  },
  {
    value: 'financeiro',
    label: 'Financeiro',
    dot: 'bg-lime-600',
    icon: 'i-lucide-banknote',
    color: 'bg-lime-100 text-lime-700',
  },
];

export const STATUSES = [
  {
    value: 'pendente',
    label: 'Pendente',
    color: 'bg-slate-100 text-slate-700',
  },
  {
    value: 'em_andamento',
    label: 'Em andamento',
    color: 'bg-blue-100 text-blue-700',
  },
  {
    value: 'concluida',
    label: 'Concluída',
    color: 'bg-emerald-100 text-emerald-700',
  },
  {
    value: 'bloqueada',
    label: 'Bloqueada',
    color: 'bg-rose-100 text-rose-700',
  },
];

export const PRIORITIES = [
  { value: 'baixa', label: 'Baixa', color: 'bg-slate-100 text-slate-700' },
  { value: 'media', label: 'Média', color: 'bg-blue-100 text-blue-700' },
  { value: 'alta', label: 'Alta', color: 'bg-amber-100 text-amber-700' },
  { value: 'critica', label: 'Crítica', color: 'bg-rose-100 text-rose-700' },
];

export const categoryMeta = v => CATEGORIES.find(c => c.value === v) || {};
export const statusMeta = v => STATUSES.find(s => s.value === v) || {};
export const priorityMeta = v => PRIORITIES.find(p => p.value === v) || {};
